import React, { useState } from "react";
import { FileDown, FileSpreadsheet, Loader2 } from "lucide-react";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const download = (sh, fmt, setBusy) => downloadFile(`/shipments/${sh.id}/report.${fmt}`, `${sh.shipment_number}-report.${fmt}`, () => setBusy(fmt), () => setBusy(""));

export const downloadFile = async (path, filename, onStart = () => {}, onEnd = () => {}) => {
  onStart();
  try {
    const token = localStorage.getItem("lac_token");
    const res = await fetch(`${API}${path}`, { credentials: "include", headers: token ? { Authorization: `Bearer ${token}` } : {} });
    if (!res.ok) throw new Error("Download failed");
    const url = window.URL.createObjectURL(await res.blob());
    const a = document.createElement("a");
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    window.URL.revokeObjectURL(url);
  } catch (e) { toast.error(e.message); } finally { onEnd(); }
};

export const ReportButtons = ({ sh }) => {
  const [busy, setBusy] = useState("");
  return (
    <div className="flex gap-2">
      <Button data-testid="button-report-pdf" size="sm" variant="outline" disabled={!!busy} onClick={() => download(sh, "pdf", setBusy)} className="border-slate-700 hover:bg-slate-800">
        {busy === "pdf" ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <FileDown size={14} className="mr-1.5" />} PDF
      </Button>
      <Button data-testid="button-report-xlsx" size="sm" variant="outline" disabled={!!busy} onClick={() => download(sh, "xlsx", setBusy)} className="border-slate-700 hover:bg-slate-800">
        {busy === "xlsx" ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <FileSpreadsheet size={14} className="mr-1.5" />} Excel
      </Button>
    </div>
  );
};
